import memoize from 'memoizee';
import { contract as currentContract } from '@/contract';
import { multiCall } from '../Calls';
import { votingescrow_abi, votingescrow_address } from '@/constants/abis';

const CRV_TOKEN_DECIMALS = 18;

const getVeCRV = memoize(async (userAddress) => {
    const contract = new currentContract.web3.eth.Contract(votingescrow_abi, votingescrow_address);
    const callsConfig = [{
        contract,
        methodName: 'balanceOf',
        params: [userAddress],
    }, {
        contract,
        methodName: 'locked__end',
        params: [userAddress],
    }];

    const [amount, lockedUntil] = await multiCall(callsConfig);

    return {
        amount: amount / (10 ** CRV_TOKEN_DECIMALS),
        lockedUntil,
    };
}, {
    promise: true,
    maxAge: 10 * 60 * 1000, // 10m
});

export default getVeCRV;
